"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreastScreeningBookingData = void 0;
var BookingData_1 = require("./BookingData");
var BreastScreeningBookingData = /** @class */ (function (_super) {
    __extends(BreastScreeningBookingData, _super);
    function BreastScreeningBookingData() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hadPreviousScan = false;
        _this.previousMammogram = undefined;
        _this.hadScanElsewhere = false;
        _this.previousElseWhereMammogram = undefined;
        _this.pregnantOrBreastfeeding = false;
        _this.existingConcerns = false;
        _this.northernIrelandResident = false;
        _this.nhsNumber = "";
        return _this;
    }
    return BreastScreeningBookingData;
}(BookingData_1.BookingData));
exports.BreastScreeningBookingData = BreastScreeningBookingData;
//# sourceMappingURL=BreastScreeningBookingData.js.map